import { AutoCompleteField, DatePickerField, InputField, Text } from '@profitowi/component-library';
import { AxiosError } from 'axios';
import { Form } from 'formik';
import useAgentId from 'pages/Agent/useAgentId';
import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';

import { AGENT } from 'constants/queries/agent';
import { createAgentsOptions } from 'helpers/agents';
import { useAgentQuery } from 'hooks/useAgentQuery';
import { getAgent } from 'services/agent';
import { AgentDetails } from 'types/agent';
import { Recommendation } from 'types/recommendation';

function BillingItemsFiltersForm({ customClasses }: { customClasses?: string }) {
  const [referredQueryAgent, setReferredQueryAgent] = useState('');
  const agentId = useAgentId();
  const { state } = useLocation();
  const { data: searchAgents } = useAgentQuery({
    queryParam: referredQueryAgent,
    minQueryLength: 3,
  });

  const recommendation: Recommendation = state?.recommendation;

  const { data: selectedAgent } = useQuery<AgentDetails, AxiosError>(
    [AGENT.AGENT, agentId],
    () => getAgent(agentId),
    { enabled: !!recommendation }
  );

  const initialSearchOptions = useMemo(() => {
    if (recommendation && selectedAgent) {
      return createAgentsOptions([selectedAgent]);
    }
    return [{ key: 0, value: '' }];
  }, [recommendation, selectedAgent]);

  const referredAgentsOption = useMemo(
    () => (searchAgents ? createAgentsOptions(searchAgents.content, 'id') : initialSearchOptions),
    [searchAgents, initialSearchOptions]
  );

  return (
    <>
      <Form className={`max-w-full ${customClasses}`}>
        <div className="my-4 flex flex-col gap-2">
          <div className="w-full">
            <DatePickerField
              dateFormat={'dd-MM-yyyy'}
              label="Data utworzenia od"
              name="DATE_FROM"
            />
          </div>
          <div className="w-full">
            <DatePickerField dateFormat={'dd-MM-yyyy'} label="Data utworzenia do" name="DATE_TO" />
          </div>
          <div className="w-full">
            <Text className="text-secondary">Agent</Text>
            <AutoCompleteField
              placeholder="Wyszukaj agenta"
              name="AGENT_ID"
              options={referredAgentsOption}
              query={referredQueryAgent}
              setQuery={setReferredQueryAgent}
            />
          </div>
          <div className="w-full mt-4">
            <InputField name="POLICY_SIGNATURE" label="Sygnatura polisy" />
          </div>
        </div>
      </Form>
    </>
  );
}

export default BillingItemsFiltersForm;
